module.exports = __webpack_public_path__ + "img/kot_logo.f63689ba.png";